import { atom } from '@reatom/framework'

import type { DelugeId } from '@root/entities/user-short'

export const userConnectionsFollowersModal = atom<
  | {
      delugeId: DelugeId
      followers: number
    }
  | undefined
>(undefined, 'userConnectionsFollowersModal')
